import { connect } from 'react-redux';
import { ICustomPropertiesFormHOCProps } from './types';
import { CustomPropertiesForm } from '../../components/CustomPropertiesForm/CustomPropertiesForm';
import { ICustomPropertiesFormEvents } from '../../components/CustomPropertiesForm/types';
import { onDropdownOptionsButton } from './events/onDropdownOptionsButton';
import { onOptionAdd } from './events/onOptionAdd';
import { onSave } from './events/onSave';
import { onChangeType } from './events/onChangeType';

const mapDispatchToProps = (
    dispatch: any,
    { cardId, boardId, onClose, onChange: onChangeOwn, onSortOptions, onEnter, setNewProperty }: ICustomPropertiesFormHOCProps
): ICustomPropertiesFormEvents => {
    return {
        onChange: (name, type, options) => dispatch(onSave(boardId, cardId, name, type, options, onChangeOwn)),
        onChangeType: (type) => dispatch(onChangeType(cardId, type)),
        onClose,
        onDropdownOptionsButton: (source) => dispatch(onDropdownOptionsButton(source)),
        onEnter,
        onOptionAdd: () => dispatch(onOptionAdd(cardId)),
        onSortOptions,
        setNewProperty,
    };
};

export const CustomPropertiesFormHOC = connect(
    null,
    mapDispatchToProps
)(CustomPropertiesForm);

CustomPropertiesFormHOC.displayName = 'CustomPropertiesFormHOC';
